import type { Renderer2 } from '@angular/core';
import { DOCUMENT, RendererFactory2, Service, inject } from '@angular/core';

@Service()
export class OverflowHelper {
  private readonly document = inject(DOCUMENT);
  private readonly rendererFactory = inject(RendererFactory2);

  private renderer: Renderer2;

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public hasOverflow(element: HTMLElement): boolean {
    const clonedElement = element.cloneNode(true) as HTMLElement;

    const computedStyles = window.getComputedStyle(element);
    for (const [property, value] of Object.entries(computedStyles)) {
      clonedElement.style.setProperty(property, value);
    }

    this.renderer.setStyle(clonedElement, 'width', 'max-content');
    this.renderer.setStyle(clonedElement, 'position', 'fixed');
    this.renderer.setStyle(clonedElement, 'visibility', 'hidden');

    const parent = element.parentNode ?? this.document.body;
    this.renderer.appendChild(parent, clonedElement);

    const isOverflowing = element.clientWidth < clonedElement.clientWidth;

    setTimeout(() => this.renderer.removeChild(parent, clonedElement));

    return isOverflowing;
  }

  public hasNoOverflow(element: HTMLElement): boolean {
    return !this.hasOverflow(element);
  }
}
